module.exports = __webpack_public_path__ + "img/footerc_3008.c4e6b42c.jpg";